export type Pagination = {
  totalCount?: number;
  totalPages?: number;
  currentPage: number;
  pageSize: number;
};

export type FileMediaLinks = {
  _id: string;
  url: string;
  thumbnail_url?: string;
  animated_gif_url?: string;
};

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}
